<template>
  <form class="form-discount-settings" v-on:submit.prevent="onSubmit">
    <h2 v-if="title" class="form-discount-settings__title">
      {{ title }}
    </h2>
    <p class="form-discount-settings__description">
      Создайте уровни и задайте процент скидки для каждого.
      Уровень повышается автоматически при достижении пациентом заданной суммы оплат.
    </p>
    <p
      v-if="!allowEditOrganizationDiscountSettings"
      class="form-discount-settings__warning-caption"
    >
      Внесение изменений возможно только в основном филиале.
    </p>
    <div class="form-discount-settings__levels">
      <div class="form-discount-settings__list">
        <discount-level
          v-for="(item, index) in value.level"
          class="form-discount-settings__item"
          v-on:input="onInput"
          v-on:delete="onDelete"
          v-bind:key="item.id || item.tmpId"
          v-bind:level-number="index + 1"
          v-bind:disabled="!allowEditOrganizationDiscountSettings"
          v-bind:disabled-delete="isLastRule"
          v-bind:violations="violations"
          v-bind:value="item"
        />
      </div>
      <button
        v-if="!maxRules"
        class="form-discount-settings__button-ordinary"
        type="button"
        v-bind:disabled="!allowEditOrganizationDiscountSettings"
        v-on:click="onAddRule">Добавить
      </button>
    </div>
    <div class="form-discount-settings__buttons">
      <button
        class="form-discount-settings__button-cancel"
        type="button"
        v-on:click="onClose">
        Отмена
      </button>
      <button
        class="form-discount-settings__button-submit"
        type="submit"
        v-bind:disabled="!hasChanged || !allowEditOrganizationDiscountSettings">
        Применить изменения
      </button>
    </div>
  </form>
</template>

<script>
import DiscountLevel from '@/components/DiscountLevel.vue';
import { DiscountSettings } from '@/mixins/loyaltySystemMixin';

export default {
  /**
   * @description Компонент формы скидочной карты
   */
  name: 'FormDiscountCard',
  components: { DiscountLevel },
  computed: {
    /**
     * @description Имеет возможность редактировать настройки скидочной системы организации
     * @returns {Boolean}
     */
    allowEditOrganizationDiscountSettings() {
      return this.value.isMainBranch;
    },
    /**
     * @description Остался последний уровень
     * @returns {Boolean}
     */
    isLastRule() {
      return this.value.level.length <= 1;
    },
    /**
     * @description Имеет изменения
     * @returns {boolean}
     */
    hasChanged() {
      return this.value.isChanged();
    },
    /**
     * @description Можно ли добавить правило
     * @returns {boolean}
     */
    maxRules() {
      return this.value.level.length >= 5;
    },
  },
  props: {
    /**
     * @description Заголовок.
     * @type {String}
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение
     * @type {DiscountSettings}
     */
    value: {
      type: DiscountSettings,
      required: true,
    },
    /**
     * @description Нарушения
     * @type {Object}
     */
    violations: { default: () => {}, type: Object },
  },
  methods: {
    onAddRule() {
      this.value.addNewLevel();
    },
    onDelete(id) {
      this.$emit('delete', id);
    },
    onSubmit() {
      this.$emit('submit');
    },
    onInput(rule) {
      this.value.updateLevel(rule);
      this.$emit('input', this.value);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.form-discount-settings {
  display: grid;
  row-gap: 10px;
  padding-block: 20px;
  &__title {
    font-size: 16px;
  }
  &__description {
    color: var(--reading-color);
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: 10px;
  }
  &__warning-caption {
    color: var(--warning-color);
  }
  &__levels {
    display: grid;
    gap: 20px;
  }
  &__list {
    display: grid;
    row-gap: 20px;
    margin-block-end: 10px;
  }
  &__item {
    display: grid;
    row-gap: 10px;
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    max-width: 438px;
    width: 100%;
    margin: 20px 0 0 auto;
  }
  &__button-ordinary {
    width: fit-content;
    color: var(--action-color);
    transition: color 0.3s;
    &:hover {
      color: #0076C4;
    }
  }
  &__button-submit {
    @include buttons.btn-blue(100%, 3rem, 1rem);
  }
  &__button-cancel {
    @include buttons.btn-transparent(100%, 3rem, 1rem);
  }
}

@media screen and (max-width: 400px) {
  .form-discount-settings {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
}

</style>
